import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Spinner from '../components/Spinner';
import '../styles/_login.scss';

const Login = ({ onLogin, resetPassword, loading, loginError, reset }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [verifyNewPassword, setVerifyNewPassword] = useState('');

  const [attemptError, setAttemptError] = useState('');
  const [forgetting, setForgetting] = useState(false);
  const [forgotMessage, setForgotMessage] = useState('');
  const [forgettingError, setForgettingError] = useState('');
  const [verifyError, setVerifyError] = useState('');
  
  const attemptLogin = () => {
    if (!loading && !forgetting) {
      setAttemptError('');
      setForgotMessage('');

      if (!email || email.replace(/\s/g, '') === '' || !password || password.replace(/\s/g, '') === '') {
        // values don't exist or are just spaces
        setAttemptError('Email and password are required.');
      } else {
        onLogin(email, password)
      }
    }
  }

  const onForgotCredentials = async () => {
    if (!loading && !forgetting) {
      // nothing is in progress
      setForgettingError('')
      setAttemptError('')

      if (!email || email.replace(/\s/g, '') === '') {
        setForgettingError('Email is required for password reset.');
      } else {
        setEmail('')
        setPassword('')
        setForgetting(true)

        try {
          const rawResponse = await fetch('/api/users/reset-password', {
            method: 'PUT',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({email})
          });

          const content = await rawResponse.json();
          if (content.error) {
            setForgettingError(content.error);
          } else {
            setForgotMessage('We emailed you a temporary password.')
          }
        } catch (error) {
          console.log(error)
        }  

        setForgetting(false)
      }
    }
  }

  useEffect(() => {
    if (reset) {
      setEmail('')
      setPassword('')
      setAttemptError('')
      setForgotMessage('')
      setForgettingError('')
      setVerifyError('')
    }
  }, [reset])

  const onResetPassword = () => {
    setVerifyError('')
    if (newPassword !== verifyNewPassword) {
      setVerifyError('Passwords must match.')
    } else if (!email || email.replace(/\s/g, '') === '') {
      setVerifyError('Must include an email.')
    } else {
      resetPassword(email, newPassword);
    }
  }

  return (
    <div className="login">
      <img className="bg" src="/bg_main.png" alt="quikquality background" />
      <div className="login-box">
        <div className="login-top">
          <img src="/logo.png" alt="quikquality logo" />
        </div>
        <div className="login-arch">
        </div>
        <div className="login-bottom">
          <h3>Web Portal</h3>
          <h4>Please sign into your account.</h4>

          <input type="text" placeholder="enter your email" value={email} onChange={(e) => setEmail(e.target.value)} className={email === '' && (attemptError !== '' || forgettingError !== '' || verifyError !== '') ? 'error' : ''}/>
          {!reset &&
            <input type="password" placeholder="enter your password" value={password} onChange={(e) => setPassword(e.target.value)} className={attemptError !== '' && password === '' ? 'error' : ''} />
          }
          {reset &&
            <Fragment>
              <input type="password" placeholder="enter a new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
              <input type="password" placeholder="verify your password" value={verifyNewPassword} onChange={(e) => setVerifyNewPassword(e.target.value)} className={verifyError !== '' && newPassword !== verifyNewPassword ? 'error' : ''}/>
            </Fragment>
          }

          { attemptError !== '' &&
            <p className="login-error">{attemptError}</p>
          }
          { forgettingError !== '' &&
            <p className="login-error">{forgettingError}</p>
          }
          { verifyError !== '' &&
            <p className="login-error">{verifyError}</p>
          }
          { (forgetting || loginError !== '') &&
            <p className="login-error">{forgetting ? <Spinner color={ 'yellow' }/> : forgotMessage ? null : loginError}</p>
          }
          { forgotMessage !== '' &&
            <p>{forgotMessage}</p>
          }

          <div className="btn primary" onClick={() => reset ? onResetPassword() : attemptLogin()}>
            {
              loading ? <Spinner /> : `${reset ? 'Reset Password' : 'Sign In'}`
            }
          </div>
          {!reset &&
            <Fragment>
              <Link className="register" to="/register">Register for an Account</Link>
              <Link className="forgot">
                <div onClick={() => onForgotCredentials()}>Forgot credentials?</div>
              </Link>
              <div className="privacy">
                <p>By signing in, you agree with our <a href="https://members.quikqualitycarwash.com/QuikQualityPrivacyPolicy.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>.</p>
              </div>
            </Fragment>
          }
        </div>
      </div>
    </div>
  )
}

export default Login